export default __webpack_public_path__ + "media/images/ui-icons_cc0000_256x240-5cbbd560bcf30acb95dd3b0b0d61645a.png";